import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreNiotixLogo',
  props: {
    color: {
      type: String,
      required: true,
      default: '#000'
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colorShades: function colorShades() {
      return [this.adjustColor(this.color, this.dark ? 0.75 : 0.25, this.dark), this.adjustColor(this.color, 0.5, this.dark)];
    },
    height: function height() {
      return this.$attrs.height || undefined;
    },
    width: function width() {
      return this.$attrs.width || undefined;
    }
  },
  methods: {
    adjustColor: function adjustColor(hexColor, alpha) {
      var dark = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var hex = hexColor.replace('#', ''); // remove potential alpha from hex code

      if (hex.length !== 6) {
        hex = hex.substring(0, 3);
      } // extend possible 3 character hex to 6 characters


      if (hex.length === 3) {
        hex = hex.replace(/([^#])/g, '$1$1');
      }

      var background = dark ? 0 : 255;

      var _hex$match$map = hex.match(/.{1,2}/g).map(function (color) {
        return Math.floor(parseInt(color, 16) * alpha + background * (1 - alpha)).toString(16).padStart(2, '0');
      }),
          _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
          r = _hex$match$map2[0],
          g = _hex$match$map2[1],
          b = _hex$match$map2[2];

      return "#".concat([r, g, b].join(''));
    }
  }
};